import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'bootstrap/js/dist/dropdown';
import moment from 'moment';
import { T, useTranslate } from 'shared/helper/translate';
import Link from 'shared/components/Link';
import { price } from 'researcher/helpers/price';
import { getChinaLocalization } from 'shared/account/reducer';
// import featureEnabled from 'shared/helper/feature';

import { getPlanExpirationStatusText, getPaddlePlanIdForCurrentPlan } from '../reducer';
import { cancelCuriePlan } from '../actions';
import PlanManagementButton from './PlanManagementButton';
import PlanStatusBadge from './PlanStatusBadge';
import PlanHeader from './PlanHeader';
import RubriqPlanDropdown from './RubriqPlanDropdown';
var PlanCard = function PlanCard(_ref) {
  var _plan$grantedFrom$pad, _plan$grantedFrom, _plan$grantedFrom$pad2, _plan$access$features;
  var plan = _ref.plan;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector.curie,
    user = _useSelector.user;
  var isChinaUser = useSelector(getChinaLocalization);
  var planEndsAtDate = moment(((_plan$grantedFrom$pad = plan.grantedFrom.paddleSubscription) === null || _plan$grantedFrom$pad === void 0 ? void 0 : _plan$grantedFrom$pad.validThrough) || plan.endsAt).utc();
  // const paddleBillingForChina = featureEnabled('rubriq_china_also_uses_paddle');

  var dispatch = useDispatch();
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var paddlePlanId = useSelector(getPaddlePlanIdForCurrentPlan);
  var isUnavailableInChina = plan.access.features.translation === null && plan.type !== 'premium';
  var onPaddleCheckoutClose = function onPaddleCheckoutClose(result) {
    if (result) {
      dispatch(cancelCuriePlan());
    }
  };
  var getPlanStatus = function getPlanStatus(plan) {
    switch (true) {
      case plan.paymentStatus === 'trialing':
        return 'trial';
      case plan.status === 'error':
        return 'error';
      case plan.status === 'active' && plan.paymentStatus === 'active':
        return 'active';
      default:
        return plan.status;
    }
  };
  var getCurrencySymbol = function getCurrencySymbol(currencyCode) {
    var formatter = new Intl.NumberFormat('en', {
      style: 'currency',
      currency: currencyCode
    });
    return formatter.formatToParts(0).find(function (part) {
      return part.type === 'currency';
    }).value;
  };
  var getCuriePlanPrice = function getCuriePlanPrice() {
    var _curie$plans, _curie$plans2;
    var planCurrency = (_curie$plans = curie.plans) === null || _curie$plans === void 0 || (_curie$plans = _curie$plans.premium) === null || _curie$plans === void 0 || (_curie$plans = _curie$plans.planPaidPrice) === null || _curie$plans === void 0 ? void 0 : _curie$plans.currency;
    var planPrice = (_curie$plans2 = curie.plans) === null || _curie$plans2 === void 0 || (_curie$plans2 = _curie$plans2.premium) === null || _curie$plans2 === void 0 || (_curie$plans2 = _curie$plans2.planPaidPrice) === null || _curie$plans2 === void 0 ? void 0 : _curie$plans2.amount;
    if (isChinaUser) {
      return price(user.currency, plan.planPrice, true, true);
    }
    if (!planPrice || !planCurrency) {
      return price(user.currency, plan.planPrice, true, true);
    }
    var currencySymbol = getCurrencySymbol(planCurrency);
    return "".concat(currencySymbol).concat(planPrice);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-4 active-subscription p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column flex-md-row justify-content-md-between align-items-md-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-start gap-2"
  }, plan.status !== 'expired' && /*#__PURE__*/React.createElement(PlanStatusBadge, {
    status: getPlanStatus(plan)
  }), /*#__PURE__*/React.createElement(PlanHeader, {
    planName: plan.planName,
    type: plan.type
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-3"
  }, plan.status !== 'expired' && /*#__PURE__*/React.createElement(Link, {
    className: "btn rubriq-btn btn-primary",
    to: "/rubriq/editing",
    role: "button"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.go-to-curie"
  })), /*#__PURE__*/React.createElement(RubriqPlanDropdown, {
    plan: plan,
    onPaddleCheckoutClose: onPaddleCheckoutClose
  }))), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column flex-md-row align-items-md-start gap-3 gap-md-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-start gap-2"
  }, plan.type === 'free_trial' && /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement(T, {
    source: "free"
  })), plan.planPrice && /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement(React.Fragment, null, getCuriePlanPrice(plan), /*#__PURE__*/React.createElement("span", {
    className: "fw-normal"
  }, ' / ', /*#__PURE__*/React.createElement(T, {
    source: plan.grantedFrom.subscriptionInterval === 'monthly' ? 'curie.month' : 'curie.year'
  })))), plan.type === 'preferred_group' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    className: "d-inline"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.group-code"
  }), ":"), /*#__PURE__*/React.createElement("span", null, " ", plan.grantedFrom.identifier)), /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: getPlanExpirationStatusText({
      plan: plan
    }),
    params: {
      day: planEndsAtDate.format('DD'),
      monthName: t(planEndsAtDate.format('MMMM')),
      year: planEndsAtDate.format('YYYY')
    }
  }), (plan.status === 'active' || plan.status === 'error') && ((_plan$grantedFrom = plan.grantedFrom) === null || _plan$grantedFrom === void 0 ? void 0 : _plan$grantedFrom.grantingMechanism) === 'paddle' && /*#__PURE__*/React.createElement(PlanManagementButton, {
    classicUrl: (_plan$grantedFrom$pad2 = plan.grantedFrom.paddleSubscription) === null || _plan$grantedFrom$pad2 === void 0 ? void 0 : _plan$grantedFrom$pad2.cancelUrl,
    targetAction: "cancel",
    onClose: onPaddleCheckoutClose,
    paddlePlanId: paddlePlanId
  }, /*#__PURE__*/React.createElement(T, {
    source: "Cancel"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-2"
  }, /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement(T, {
    source: "curie.details"
  }), ":"), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-2"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "d-flex flex-column gap-2 m-0 rubriq-plan-feature-list"
  }, isChinaUser && plan.planName === 'premium_editing' ? /*#__PURE__*/React.createElement("li", {
    className: "".concat(plan.access.features.editing === null ? 'unavailable' : '')
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.plan-editing-available"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", {
    className: "".concat(plan.access.features.editing === null ? 'unavailable' : '')
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.plan-editing-available"
  })), plan.planName !== 'premium_editing_only' && plan.planName !== 'premium_editing_only_no_trial' && /*#__PURE__*/React.createElement(React.Fragment, null, plan.type !== 'free_trial' && /*#__PURE__*/React.createElement("li", {
    className: isUnavailableInChina ? 'unavailable' : ''
  }, isUnavailableInChina ? /*#__PURE__*/React.createElement(T, {
    source: "curie.translation-features"
  }) : /*#__PURE__*/React.createElement(T, {
    source: "rubriq.my-plan-details-unlimited-Chinese-translations"
  })), /*#__PURE__*/React.createElement("li", {
    className: "".concat(isUnavailableInChina ? 'unavailable' : '')
  }, isUnavailableInChina ? /*#__PURE__*/React.createElement(T, {
    source: "curie.translation-features"
  }) : /*#__PURE__*/React.createElement(T, {
    source: plan.type === 'preferred_group' ? "%s translations available" : "%s translations per month",
    params: plan.type === 'preferred_group' ? (_plan$access$features = plan.access.features.translation) === null || _plan$access$features === void 0 ? void 0 : _plan$access$features.usesRemaining : 2
  })))))), plan.type === 'preferred_group' && (plan.access.features.editing === null || plan.access.features.translation === null) && /*#__PURE__*/React.createElement(T, {
    source: "curie.contact-group-admin"
  }))));
};
export default PlanCard;